import React from "react";
import Image from "next/image";
import CustomIcon from "components/CustomIcon";
import { useDispatch } from "react-redux";
import { highlightMistakes, clearHighlight } from "lib/redux/highlightSlice";
import type { SectionType, MistakeType } from "lib/redux/highlightSlice";

interface WordMistakesSectionProps {
  title: string;
  icon: string;
  mistakes: string[];
  // New props for highlighting context
  section?: SectionType;
  itemIndex?: number | null;
  mistakeType?: MistakeType;
}

export const WordMistakesSection: React.FC<WordMistakesSectionProps> = ({
  title,
  icon,
  mistakes,
  section = "experience",
  itemIndex = null,
  mistakeType = "spelling",
}) => {
  const dispatch = useDispatch();

  

  // Handle hover on individual mistake item
  const handleMistakeMouseEnter = (mistake: string) => {
    dispatch(
      highlightMistakes({
        section,
        itemIndex,
        mistakeType,
        texts: [mistake], 
      })
    );
  };

  const handleMouseLeave = () => {
    dispatch(clearHighlight());
  };
  // console.log(mistakes);

  return (
    <div
      className="relative mt-4 md:mt-3 flex flex-col gap-[8px] rounded-xl bg-[#FEE7E4] px-[10px] py-[8px] sm:gap-[10px] sm:px-[15px] sm:py-[10px] lg:gap-[16px] lg:px-[20px] lg:py-[14px]"
    >
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src={`/icons/score-check/${icon}.svg`}
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          {title}
        </span>
      </div>
      <ul className=" mt-4 md:mt-3 flex list-disc flex-col items-start px-[3px] marker:text-base marker:text-[#92C5FF] sm:px-[5px] sm:marker:text-lg lg:marker:text-2xl">
        {mistakes.map((mistake, idx) => (
          <li
            key={idx}
            className="my-[6px] pl-2 xl:pl-3 flex cursor-pointer items-center gap-2 text-xs font-normal text-[#B94444] w-full bg-[#FDFDFD] p-2 rounded-lg transition-opacity hover:opacity-80 md:text-base lg:my-[6px] lg:gap-4 lg:text-base xl:my-[10px] "
            onMouseEnter={() => handleMistakeMouseEnter(mistake)}
            onMouseLeave={handleMouseLeave}
          >
            {/* <div className="h-auto w-auto">
              <CustomIcon iconName="cross" className="h-3 w-3 lg:h-4 lg:w-4" />
            </div> */}
            {mistake}
          </li>
        ))}
      </ul>
      <div className="mt-4 flex flex-col items-center justify-center gap-1">
        <p className="text-center text-sm font-semibold text-red-600 lg:text-base">
          Mistakes can weaken your resume
        </p>
        <div className="relative h-32 w-44">
          <Image
            src="/assets/resumeScore/grammar.png"
            alt="Word mistakes illustration"
            fill
            className="h-10 w-15"
          />
        </div>
        <p className="text-center text-xs text-gray-600 lg:text-sm">
          Small errors can distract from your achievements. Make sure to proofread and correct them.
        </p>
      </div>
    </div>
  );
};
